import * as React from 'react'
import { Typography } from '@leshen/ui'

const AvailabilitySubmissionMessage = () => (
  <Typography variant="body">Thank you for your submission.</Typography>
)

export default AvailabilitySubmissionMessage
